export const environment = {
  production: true,
  version: '97a847e8aa',
  site_version: 'SITE_VERSION'
};
